import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, Icon, Input } from "@chakra-ui/react";
import "./Autocomplete.css";

function AutocompleteSelect({
  name,
  label,
  placeholder,
  apiIndex,
  fetchParams = {},
  setSelectedItem,
  itemLabel,
  valuesToSelect,
  isRequired = false,
}) {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);

  const openPanel = () => {
    setIsPanelOpen(!isPanelOpen);
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case "ArrowDown":
        setIsPanelOpen(true);
        setFocusedIndex((prevIndex) =>
          prevIndex < options.length - 1 ? prevIndex + 1 : 0
        );
        break;
      case "ArrowUp":
        setFocusedIndex((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : options.length - 1
        );
        break;
      case "Enter":
        e.preventDefault();
        if (focusedIndex >= 0 && focusedIndex < options.length) {
          const selectedOption = options[focusedIndex];
          setSelectedItem(valuesToSelect(selectedOption));
          setInputValue(itemLabel(selectedOption));
          setIsPanelOpen(false);
        }
        break;
      case "Escape":
        setIsPanelOpen(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_SEARCH_API_BASE_URL;
    const apiKey = process.env.REACT_APP_SEARCH_API_KEY;

    const fetchOptions = async () => {
      try {
        const response = await fetch(`${baseUrl}/${apiIndex}/search`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "/*/",
            Authorization: `Bearer ${apiKey}`,
          },
          body: JSON.stringify(fetchParams),
        });
        const data = await response.json();
        const { hits } = data;
        setOptions(hits || []);
      } catch (error) {
        console.error("Error fetching options: ", error);
      }
    };

    fetchOptions();
  }, [apiIndex, fetchParams]);

  return (
    <FormControl isRequired={isRequired}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <div
        className="select-wrapper"
        onClick={openPanel}
        onKeyDown={handleKeyDown}
      >
        <Input
          type="text"
          id={name}
          name={name}
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          autoComplete="off"
        />
        <Icon
          name="chevron-down"
          className="select-icon"
          data-open={isPanelOpen}
        >
          <svg
            viewBox="0 0 24 24"
            role="presentation"
            focusable="false"
            aria-hidden="true"
            style={{ width: "1em", height: "1em", color: "current-color" }}
          >
            <path
              fill="currentColor"
              d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
            ></path>
          </svg>
        </Icon>
        {isPanelOpen && (
          <ul className="suggestions-list">
            {options.map((option, index) => (
              <li
                key={index}
                className={`suggestion-item ${
                  index === focusedIndex ? "focused" : ""
                }`}
                onClick={() => {
                  setSelectedItem(valuesToSelect(option));
                  setInputValue(itemLabel(option));
                  setIsPanelOpen(false);
                }}
                onMouseEnter={() => setFocusedIndex(index)}
              >
                {itemLabel(option)}
              </li>
            ))}
          </ul>
        )}
      </div>
    </FormControl>
  );
}

export default AutocompleteSelect;
